import axios, { AxiosPromise } from 'axios';

const stahnoutSRDApi = (file: string): AxiosPromise<{ redirect: string }> => {
    return axios({
        method: 'GET',
        url: 'SRD/Download/Prepare',
        params: {
            file
        }
    });
};
export default stahnoutSRDApi;
